import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FiSave } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";
import { Editor } from "@tinymce/tinymce-react";

//  Resmin gerçek (width/height) değerlerini döndürür
function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(url);
    };
    img.onerror = reject;
    img.src = url;
  });
}

const MailTemplateEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, fallback = "") => translations[key] || fallback;

  const [loading, setLoading] = useState(true);
  const [templateData, setTemplateData] = useState({
    title: "",
    content: "",
    status: "active",
  });

  // Şablonu backend'den çek
  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/mail-templates/${id}`);
        setTemplateData({
          title: resp.data.title,
          content: resp.data.content || "",
          status: resp.data.status || "active",
        });
      } catch (error) {
        console.error("❌ Şablon bilgisi alınamadı:", error);
        toast.error(getText("ERROR_TEMPLATE_FETCH_FAILED"));
      } finally {
        setLoading(false);
      }
    };
    fetchTemplate();
  }, [id]);

  // Input değişimi
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTemplateData((prev) => ({ ...prev, [name]: value }));
  };

  // TinyMCE içeriği değişince
  const handleEditorChange = (content) => {
    setTemplateData((prev) => ({ ...prev, content }));
  };

  // Güncelleme isteği (PUT)
  const updateTemplate = async () => {
    if (!templateData.title.trim() || !templateData.content.trim()) {
      toast.warn(getText("WARNING_EMPTY_FIELDS"));
      return;
    }

    try {
      await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/mail-templates/${id}`, templateData);
      toast.success(getText("SUCCESS_TEMPLATE_UPDATED"));
      // navigate("/settings/mail-templates");
    } catch (error) {
      console.error("❌ Şablon güncellenemedi:", error);
      toast.error(getText("ERROR_TEMPLATE_UPDATE_FAILED"));
    }
  };

  if (loading) {
    return (
      <div className="container mt-4">
        <ToastContainer />
        <div className="text-center my-4">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{getText("LOADING")}</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <ToastContainer />

      <div className="card card-body lead-info mb-4">
        <div className="d-flex align-items-center justify-content-between mb-3">
     
        </div>

        {/* BAŞLIK */}
        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LABEL_TITLE")}</label>
          <input
            type="text"
            name="title"
            className="form-control"
            value={templateData.title}
            onChange={handleChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">{getText("LABEL_CONTENT")}</label>
          <Editor
              tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
              value={templateData.content}
              onEditorChange={handleEditorChange}
              init={{
                promotion: false,
                height: 500,
                plugins: [
                  "advlist", "autolink", "link", "image", "lists", "charmap",
                  "preview", "anchor", "pagebreak", "searchreplace", "wordcount",
                  "visualblocks", "code", "fullscreen", "insertdatetime", "media",
                  "table", "emoticons", "help"
                ],
                toolbar:
                  "undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | " +
                  "bullist numlist outdent indent | link image | " +
                  "print preview media fullscreen code | forecolor backcolor emoticons | help",
                content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
                image_advtab: true,
                automatic_uploads: true, 
                images_upload_url: `${process.env.REACT_APP_API_BASE_URL}/api/mail-templates/upload`,
                images_upload_handler: null, 
                
                relative_urls: false,
                remove_script_host: false,
                convert_urls: false,
              }}
            />

        </div>

        <div className="d-flex justify-content-center">
          <button className="btn btn-primary" onClick={updateTemplate}>
            <FiSave /> {getText("SAVE_BTN")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MailTemplateEdit;
